// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__LCxZB","lightBackground":"Button_lightBackground____akq","darkBackground":"Button_darkBackground__NgJpN"};